import React from 'react';
import PropTypes from 'prop-types';
import { Button, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronLeft,
  faChevronRight
} from '@fortawesome/free-solid-svg-icons';

/**
 * Server-side pagination footer for the registration queue (U3.3). The list
 * endpoint pages on the server (`page` / `limit` → `total`), so this replaces
 * AdvanceTableFooter's client-side paging while keeping its look.
 */
const QueuePagination = ({
  page,
  limit,
  total,
  onPageChange,
  onLimitChange,
  disabled = false,
  limitOptions = [10, 25, 50]
}) => {
  const pageCount = Math.max(1, Math.ceil(total / limit));
  const from = total === 0 ? 0 : (page - 1) * limit + 1;
  const to = Math.min(total, page * limit);

  return (
    <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 fs-10">
      <div className="text-700">
        Showing{' '}
        <strong>
          {from}–{to}
        </strong>{' '}
        of <strong>{total}</strong>
      </div>
      <div className="d-flex align-items-center gap-2">
        <label
          htmlFor="registration-queue-limit"
          className="text-600 mb-0 d-none d-sm-inline"
        >
          Rows per page
        </label>
        <Form.Select
          id="registration-queue-limit"
          size="sm"
          className="w-auto"
          value={limit}
          disabled={disabled}
          onChange={e => onLimitChange(Number(e.target.value))}
        >
          {limitOptions.map(option => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </Form.Select>
        <Button
          size="sm"
          variant="falcon-default"
          disabled={disabled || page <= 1}
          onClick={() => onPageChange(page - 1)}
          aria-label="Previous page"
        >
          <FontAwesomeIcon icon={faChevronLeft} />
        </Button>
        <span className="text-700 text-nowrap">
          Page {page} of {pageCount}
        </span>
        <Button
          size="sm"
          variant="falcon-default"
          disabled={disabled || page >= pageCount}
          onClick={() => onPageChange(page + 1)}
          aria-label="Next page"
        >
          <FontAwesomeIcon icon={faChevronRight} />
        </Button>
      </div>
    </div>
  );
};

QueuePagination.propTypes = {
  page: PropTypes.number.isRequired,
  limit: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onLimitChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  limitOptions: PropTypes.arrayOf(PropTypes.number)
};

export default QueuePagination;
